var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowHotspot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_428_64331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1207 72.0396C66.4556 70.1142 69.2875 67.4269 71.3848 64.1973C73.4821 60.9677 74.7853 57.2877 75.1878 53.4579L50.92 50.9073L63.1207 72.0396Z",
    fill: "green",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1578 75.5625C69.0485 73.3162 72.3524 70.1809 74.7992 66.4131C77.2461 62.6453 78.7664 58.3519 79.236 53.8839L50.9236 50.9081L65.1578 75.5625Z",
    fill: "green",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.187 79.0854C71.6336 76.5181 75.4094 72.935 78.2058 68.6289C81.0022 64.3229 82.7398 59.4161 83.2765 54.3098L50.9194 50.9089L67.187 79.0854Z",
    fill: "green",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2241 82.6082C74.2264 79.7201 78.4742 75.6891 81.6202 70.8448C84.7661 66.0004 86.7209 60.4803 87.3247 54.7357L50.923 50.9097L69.2241 82.6082Z",
    fill: "green",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5173 50.9093C26.5173 47.0585 27.4287 43.2624 29.1769 39.8313C30.9252 36.4002 33.4606 33.4315 36.576 31.1681L50.9188 50.9093L26.5173 50.9093Z",
    fill: "green",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4538 50.9098C22.4538 46.4172 23.5171 41.9884 25.5567 37.9854C27.5963 33.9825 30.5543 30.5191 34.1889 27.8784L50.9222 50.9098L22.4538 50.9098Z",
    fill: "green",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3825 50.9103C18.3825 45.7759 19.5976 40.7144 21.9286 36.1396C24.2596 31.5648 27.6402 27.6066 31.794 24.5887L50.9178 50.9103L18.3825 50.9103Z",
    fill: "green",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.319 50.9108C14.319 45.1346 15.686 39.4404 18.3084 34.2938C20.9307 29.1471 24.7339 24.6942 29.4069 21.299L50.9212 50.9108L14.319 50.9108Z",
    fill: "green",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7924 63.1129C31.7178 66.4478 34.4052 69.2797 37.6347 71.377C40.8643 73.4743 44.5444 74.7775 48.3741 75.18L50.9248 50.9122L29.7924 63.1129Z",
    fill: "green",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2696 65.1461C28.5159 69.0368 31.6511 72.3406 35.4189 74.7875C39.1867 77.2343 43.4802 78.7547 47.9482 79.2243L50.9239 50.9119L26.2696 65.1461Z",
    fill: "green",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7467 67.1792C25.3139 71.6257 28.897 75.4016 33.2031 78.198C37.5092 80.9944 42.4159 82.732 47.5222 83.2686L50.9231 50.9116L22.7467 67.1792Z",
    fill: "green",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2238 69.2124C22.1119 74.2147 26.1429 78.4625 30.9873 81.6085C35.8316 84.7544 41.3517 86.7092 47.0963 87.313L50.9223 50.9112L19.2238 69.2124Z",
    fill: "green",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9188 26.5095C54.7696 26.5095 58.5658 27.4209 61.9969 29.1691C65.428 30.9173 68.3966 33.4528 70.66 36.5682L50.9188 50.911L50.9188 26.5095Z",
    fill: "green",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9222 22.4421C55.4148 22.4421 59.8437 23.5053 63.8466 25.545C67.8496 27.5846 71.313 30.5426 73.9536 34.1772L50.9222 50.9105L50.9222 22.4421Z",
    fill: "green",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9178 18.3747C56.0522 18.3747 61.1137 19.5898 65.6885 21.9208C70.2633 24.2518 74.2215 27.6324 77.2394 31.7862L50.9178 50.91L50.9178 18.3747Z",
    fill: "green",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9212 14.3072C56.6974 14.3072 62.3916 15.6743 67.5383 18.2966C72.6849 20.919 77.1379 24.7222 80.533 29.3952L50.9212 50.9095L50.9212 14.3072Z",
    fill: "green",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.9253,
    cy: 50.9136,
    r: 18.9956,
    fill: "green"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_428_64331",
    x: 8.32031,
    y: 8.30859,
    width: 93.0078,
    height: 93.0039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_428_64331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_428_64331",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowHotspot);
export default __webpack_public_path__ + "static/media/yellowHotspot.bb6caf054a40f5151c8d6407495c57f5.svg";
export { ForwardRef as ReactComponent };